import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { local, staging } from '../core/config/env.file';
import { development } from '../core/config/env.file';
import { uat, production } from '../core/config/env.file';



@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  
  constructor(
    private readonly router: Router,
    private readonly oauthService: OAuthService  // Correctly use OAuthService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // Check if user has valid access token
    if (this.isValidTokenPresent()) {
      return true;
    } else {
      if (window.location.href.includes('cst.dev') || window.location.href.includes('landlord.dev') || window.location.href.includes('seeker.dev') || window.location.href.includes('provider.dev')) {
        window.location.href = `${development.publicSite}/auth/login`;
      }
      else if (window.location.href.includes('cst.qa') || window.location.href.includes('landlord.qa') || window.location.href.includes('seeker.qa') || window.location.href.includes('provider.qa')) {
        window.location.href = `${staging.publicSite}/auth/login`;
      }
      else if (window.location.href.includes('cst.uat') || window.location.href.includes('landlord.uat') || window.location.href.includes('seeker.uat') || window.location.href.includes('provider.uat')) {
        window.location.href = `${uat.publicSite}/auth/login`;
      }
      else if (['cst.infrareg.sa', 'landlord.infrareg.sa', 'seeker.infrareg.sa', 'provider.infrareg.sa'].some(domain => window.location.href.includes(domain))) {
        window.location.href = `${production.publicSite}/auth/login`;
      }   
      else{
       window.location.href = `${local.publicSite}/auth/login`;

      }
      return false;
    }
  }

  /**
   * Comprehensive token validation
   */
  private isValidTokenPresent(): boolean {
    // Strategy 1: Check OAuth service
    if (this.oauthService.hasValidAccessToken()) {
      return true;
    }

    // Strategy 2: Check localStorage and validate token manually
    const accessToken = localStorage.getItem('access_token');
    if (accessToken && this.isTokenValid(accessToken)) {
      return true;
    }

    return false;
  }

  /**
   * Validates token expiration
   */
  private isTokenValid(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const exp = payload.exp * 1000; // Convert to milliseconds
      const now = Date.now();
      return exp > now;
    } catch (error) {
      // Token parsing failed - treat as invalid
      console.debug('Token validation failed:', error);
      return false;
    }
  }
}